import { render, staticRenderFns } from "./Error-page.vue?vue&type=template&id=5c7a2dea&scoped=true&"
import script from "./Error-page.vue?vue&type=script&lang=js&"
export * from "./Error-page.vue?vue&type=script&lang=js&"
import style0 from "./Error-page.vue?vue&type=style&index=0&id=5c7a2dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a2dea",
  null
  
)

export default component.exports